module.exports = __webpack_public_path__ + "img/equipos-de-sala.59c76315.jpg";